/**
 * Translation: NL - Scorecard
 * Note, also export in translations/{LANGUAGE}/index.js
 */
export default {
  'scorecard.form.title': 'Scorekaart invullen',
  'scorecard.completed.title': 'Scorekaart ingestuurd',
  'scorecard.view.title': 'Overzicht',
  'scorecard.total.title': 'Totaal',
  'scorecard.course-handicap.title': 'Baanhandicap',
  'scorecard.score.title': 'Score',

  'scorecard.basics.type.label': 'Type scorekaart',
  'scorecard.basics.type.placeholder': 'Maak een keuze',
  'scorecard.basics.type.label.non_qualifying': 'Practice Card',
  'scorecard.basics.type.label.match': 'Match Card',
  'scorecard.basics.type.label.qualifying': 'Qualifying Card',
  'scorecard.basics.type.label.nonNL': 'Non-NL card',
  'scorecard.basics.type.value.non_qualifying': 'non_qualifying',
  'scorecard.basics.type.value.match': 'match',
  'scorecard.basics.type.value.qualifying': 'qualifying',
  'scorecard.basics.type.value.nonNL': 'nonNL',

  'scorecard.basics.country.label': 'Land',
  'scorecard.basics.country.af': 'Afghanistan',
  'scorecard.basics.country.ax': 'Åland',
  'scorecard.basics.country.al': 'Albanië',
  'scorecard.basics.country.dz': 'Algerije',
  'scorecard.basics.country.as': 'Amerikaans Samoa',
  'scorecard.basics.country.vi': 'Amerikaanse Maagdeneilanden',
  'scorecard.basics.country.ad': 'Andorra',
  'scorecard.basics.country.ao': 'Angola',
  'scorecard.basics.country.ai': 'Anguilla',
  'scorecard.basics.country.aq': 'Antarctica',
  'scorecard.basics.country.ag': 'Antigua en Barbuda',
  'scorecard.basics.country.ar': 'Argentinië',
  'scorecard.basics.country.am': 'Armenië',
  'scorecard.basics.country.aw': 'Aruba',
  'scorecard.basics.country.au': 'Australië',
  'scorecard.basics.country.az': 'Azerbeidzjan',
  'scorecard.basics.country.bs': 'Bahamas',
  'scorecard.basics.country.bh': 'Bahrein',
  'scorecard.basics.country.bd': 'Bangladesh',
  'scorecard.basics.country.bb': 'Barbados',
  'scorecard.basics.country.be': 'België',
  'scorecard.basics.country.bz': 'Belize',
  'scorecard.basics.country.bj': 'Benin',
  'scorecard.basics.country.bm': 'Bermuda',
  'scorecard.basics.country.bt': 'Bhutan',
  'scorecard.basics.country.bo': 'Bolivia',
  'scorecard.basics.country.ba': 'Bosnië-Herzegovina',
  'scorecard.basics.country.bw': 'Botswana',
  'scorecard.basics.country.bv': 'Bouveteiland',
  'scorecard.basics.country.br': 'Brazilië',
  'scorecard.basics.country.io': 'Brits Indische Oceaanterritorium',
  'scorecard.basics.country.vg': 'Britse Maagdeneilanden',
  'scorecard.basics.country.bn': 'Brunei',
  'scorecard.basics.country.bg': 'Bulgarije',
  'scorecard.basics.country.bf': 'Burkina Faso',
  'scorecard.basics.country.bi': 'Burundi',
  'scorecard.basics.country.kh': 'Cambodja',
  'scorecard.basics.country.ca': 'Canada',
  'scorecard.basics.country.cf': 'Centraal Afrikaanse Republiek',
  'scorecard.basics.country.td': 'Chad',
  'scorecard.basics.country.cl': 'Chili',
  'scorecard.basics.country.cn': 'China',
  'scorecard.basics.country.cx': 'Christmaseiland',
  'scorecard.basics.country.cc': 'Cocoseilanden',
  'scorecard.basics.country.co': 'Colombia',
  'scorecard.basics.country.km': 'Comoren',
  'scorecard.basics.country.cg': 'Congo',
  'scorecard.basics.country.cd': 'Congo-Kinshasa',
  'scorecard.basics.country.ck': 'Cookeilanden',
  'scorecard.basics.country.cr': 'Costa Rica',
  'scorecard.basics.country.cu': 'Cuba',
  'scorecard.basics.country.cy': 'Cyprus',
  'scorecard.basics.country.dk': 'Denemarken',
  'scorecard.basics.country.dj': 'Djibouti',
  'scorecard.basics.country.dm': 'Dominica',
  'scorecard.basics.country.do': 'Dominicaanse Republiek',
  'scorecard.basics.country.de': 'Duitsland',
  'scorecard.basics.country.ec': 'Ecuador',
  'scorecard.basics.country.eg': 'Egypte',
  'scorecard.basics.country.sv': 'El Salvador',
  'scorecard.basics.country.gq': 'Equatoriaal-Guinea',
  'scorecard.basics.country.er': 'Eritrea',
  'scorecard.basics.country.ee': 'Estland',
  'scorecard.basics.country.sz': 'eSwatini',
  'scorecard.basics.country.et': 'Ethiopië',
  'scorecard.basics.country.fk': 'Falklandeilanden',
  'scorecard.basics.country.fo': 'Faeröer',
  'scorecard.basics.country.fj': 'Fiji',
  'scorecard.basics.country.ph': 'Filipijnen',
  'scorecard.basics.country.fi': 'Finland',
  'scorecard.basics.country.fr': 'Frankrijk',
  'scorecard.basics.country.gf': 'Frans-Guyana',
  'scorecard.basics.country.pf': 'Frans-Polynesië',
  'scorecard.basics.country.tf': 'Franse Zuidelijke en Antarctische Gebieden ',
  'scorecard.basics.country.ga': 'Gabon',
  'scorecard.basics.country.gm': 'Gambia',
  'scorecard.basics.country.ge': 'Georgië',
  'scorecard.basics.country.gh': 'Ghana',
  'scorecard.basics.country.gi': 'Gibraltar',
  'scorecard.basics.country.gr': 'Griekenland',
  'scorecard.basics.country.gl': 'Groenland',
  'scorecard.basics.country.gd': 'Grenada',
  'scorecard.basics.country.gp': 'Guadeloupe',
  'scorecard.basics.country.gu': 'Guam',
  'scorecard.basics.country.gt': 'Guatemala',
  'scorecard.basics.country.gg': 'Guernsey',
  'scorecard.basics.country.gn': 'Guinee',
  'scorecard.basics.country.gw': 'Guinee-Bissau',
  'scorecard.basics.country.gy': 'Guyana',
  'scorecard.basics.country.ht': 'Haïti',
  'scorecard.basics.country.hm': 'Heard en MacDonaldeilanden',
  'scorecard.basics.country.hn': 'Honduras',
  'scorecard.basics.country.hk': 'Hong Kong',
  'scorecard.basics.country.hu': 'Hongarije',
  'scorecard.basics.country.ie': 'Ierland',
  'scorecard.basics.country.is': 'IJsland',
  'scorecard.basics.country.in': 'India',
  'scorecard.basics.country.id': 'Indonesië',
  'scorecard.basics.country.iq': 'Irak',
  'scorecard.basics.country.ir': 'Iran',
  'scorecard.basics.country.im': 'Isle of Man',
  'scorecard.basics.country.il': 'Israël',
  'scorecard.basics.country.it': 'Italë',
  'scorecard.basics.country.ci': 'Ivoorkust',
  'scorecard.basics.country.jm': 'Jamaica',
  'scorecard.basics.country.jp': 'Japan',
  'scorecard.basics.country.ye': 'Jemen',
  'scorecard.basics.country.je': 'Jersey',
  'scorecard.basics.country.jo': 'Jordanië',
  'scorecard.basics.country.ky': 'Kaaimaneilanden',
  'scorecard.basics.country.cv': 'Kaapverdië',
  'scorecard.basics.country.cm': 'Kameroen',
  'scorecard.basics.country.kz': 'Kazachstan',
  'scorecard.basics.country.ke': 'Kenia',
  'scorecard.basics.country.ki': 'Kiribati',
  'scorecard.basics.country.kw': 'Koeweit',
  'scorecard.basics.country.kg': 'Kirgistan',
  'scorecard.basics.country.um': 'Kleine Afgelegen Eilanden van de Verenigde Staten',
  'scorecard.basics.country.hr': 'Kroatië',
  'scorecard.basics.country.la': 'Laos',
  'scorecard.basics.country.lv': 'Letland',
  'scorecard.basics.country.ls': 'Lesotho',
  'scorecard.basics.country.lb': 'Libanon',
  'scorecard.basics.country.lr': 'Liberia',
  'scorecard.basics.country.ly': 'Libië',
  'scorecard.basics.country.li': 'Liechtenstein',
  'scorecard.basics.country.lt': 'Litouwen',
  'scorecard.basics.country.lu': 'Luxemburg',
  'scorecard.basics.country.mo': 'Macao',
  'scorecard.basics.country.mk': 'Macedonië',
  'scorecard.basics.country.mg': 'Madagaskar',
  'scorecard.basics.country.mw': 'Malawi',
  'scorecard.basics.country.mv': 'Maldiven',
  'scorecard.basics.country.my': 'Maleisië',
  'scorecard.basics.country.ml': 'Mali',
  'scorecard.basics.country.mt': 'Malta',
  'scorecard.basics.country.ma': 'Marokko',
  'scorecard.basics.country.mh': 'Marshalleilanden',
  'scorecard.basics.country.mq': 'Martinique',
  'scorecard.basics.country.mr': 'Mauritanië',
  'scorecard.basics.country.mu': 'Mauritius',
  'scorecard.basics.country.yt': 'Mayotte',
  'scorecard.basics.country.mx': 'Mexico',
  'scorecard.basics.country.fm': 'Micronesia',
  'scorecard.basics.country.md': 'Moldavië',
  'scorecard.basics.country.mc': 'Monaco',
  'scorecard.basics.country.mn': 'Mongolië',
  'scorecard.basics.country.ms': 'Montserrat',
  'scorecard.basics.country.mz': 'Mozambique',
  'scorecard.basics.country.mm': 'Myanmar',
  'scorecard.basics.country.na': 'Namibië',
  'scorecard.basics.country.nr': 'Nauru',
  'scorecard.basics.country.nl': 'Nederland',
  'scorecard.basics.country.an': 'Nederlandse Antillen',
  'scorecard.basics.country.np': 'Nepal',
  'scorecard.basics.country.nc': 'Nieuw-Caledonië',
  'scorecard.basics.country.nz': 'Nieuw-Zeeland',
  'scorecard.basics.country.ni': 'Nicaragua',
  'scorecard.basics.country.ne': 'Niger',
  'scorecard.basics.country.ng': 'Nigeria',
  'scorecard.basics.country.nu': 'Niue',
  'scorecard.basics.country.kp': 'Noord-Korea',
  'scorecard.basics.country.mp': 'Noordelijke Marianen',
  'scorecard.basics.country.no': 'Noorwegen',
  'scorecard.basics.country.nf': 'Norfolkeiland',
  'scorecard.basics.country.ua': 'Oekraïne',
  'scorecard.basics.country.uz': 'Oezbekistan',
  'scorecard.basics.country.om': 'Oman',
  'scorecard.basics.country.at': 'Oostenrijk',
  'scorecard.basics.country.tl': 'Oost-Timor',
  'scorecard.basics.country.pk': 'Pakistan',
  'scorecard.basics.country.pw': 'Palau',
  'scorecard.basics.country.ps': 'Palestijnse territoria',
  'scorecard.basics.country.pa': 'Panama',
  'scorecard.basics.country.pg': 'Papoea-Nieuw-Guinea',
  'scorecard.basics.country.py': 'Paraguay',
  'scorecard.basics.country.pe': 'Peru',
  'scorecard.basics.country.pn': 'Pitcairneilanden',
  'scorecard.basics.country.pl': 'Polen',
  'scorecard.basics.country.pt': 'Portugal',
  'scorecard.basics.country.pr': 'Puerto Rico',
  'scorecard.basics.country.qa': 'Qatar',
  'scorecard.basics.country.re': 'Réunion',
  'scorecard.basics.country.ro': 'Roemenië',
  'scorecard.basics.country.ru': 'Rusland',
  'scorecard.basics.country.rw': 'Rwanda',
  'scorecard.basics.country.kn': 'Saint Kitts en Nevis',
  'scorecard.basics.country.lc': 'Saint Lucia',
  'scorecard.basics.country.pm': 'Saint-Pierre en Miquelon',
  'scorecard.basics.country.vc': 'Saint Vincent en de Grenadines',
  'scorecard.basics.country.ws': 'Samoa',
  'scorecard.basics.country.sm': 'San Marino',
  'scorecard.basics.country.st': 'Sao Tomé en Principee',
  'scorecard.basics.country.sa': 'Saudi-Arabië',
  'scorecard.basics.country.sn': 'Senegal',
  'scorecard.basics.country.cs': 'Servië en Montenegro',
  'scorecard.basics.country.sc': 'Seychellen',
  'scorecard.basics.country.sl': 'Sierra Leone',
  'scorecard.basics.country.sg': 'Singapore',
  'scorecard.basics.country.sh': 'Sint-Helena',
  'scorecard.basics.country.sk': 'Slowakije',
  'scorecard.basics.country.si': 'Slovenië',
  'scorecard.basics.country.sb': 'Solomoneilanden',
  'scorecard.basics.country.so': 'Somalië',
  'scorecard.basics.country.es': 'Spanje',
  'scorecard.basics.country.sj': 'Spitsbergen',
  'scorecard.basics.country.lk': 'Sri Lanka',
  'scorecard.basics.country.sd': 'Sudan',
  'scorecard.basics.country.sr': 'Suriname',
  'scorecard.basics.country.sy': 'Syrië',
  'scorecard.basics.country.tw': 'Taiwan',
  'scorecard.basics.country.tj': 'Tadzjikistan',
  'scorecard.basics.country.tz': 'Tanzania',
  'scorecard.basics.country.th': 'Thailand',
  'scorecard.basics.country.tg': 'Togo',
  'scorecard.basics.country.tk': 'Tokelau',
  'scorecard.basics.country.to': 'Tonga',
  'scorecard.basics.country.tt': 'Trinidad en Tobago',
  'scorecard.basics.country.cz': 'Tsjechië',
  'scorecard.basics.country.tn': 'Tunisië',
  'scorecard.basics.country.tr': 'Turkije',
  'scorecard.basics.country.tm': 'Turkmenistan',
  'scorecard.basics.country.tc': 'Turks- en Caicoseilanden',
  'scorecard.basics.country.tv': 'Tuvalu',
  'scorecard.basics.country.ug': 'Uganda',
  'scorecard.basics.country.uy': 'Uruguay',
  'scorecard.basics.country.vu': 'Vanuatu',
  'scorecard.basics.country.va': 'Vaticaanstad',
  'scorecard.basics.country.ve': 'Venezuela',
  'scorecard.basics.country.ae': 'Verenigde Arabische Emiraten',
  'scorecard.basics.country.gb': 'Verenigd Koninkrijk',
  'scorecard.basics.country.us': 'Verenigde Staten',
  'scorecard.basics.country.vn': 'Vietnam',
  'scorecard.basics.country.wf': 'Wallis en Futuna',
  'scorecard.basics.country.eh': 'Westelijke Sahara',
  'scorecard.basics.country.by': 'Wit-Rusland',
  'scorecard.basics.country.zm': 'Zambia',
  'scorecard.basics.country.zw': 'Zimbabwe',
  'scorecard.basics.country.za': 'Zuid-Afrika',
  'scorecard.basics.country.gs': 'Zuid-Georgia en de Zuidelijke Sandwicheilanden',
  'scorecard.basics.country.kr': 'Zuid-Korea',
  'scorecard.basics.country.se': 'Zweden',
  'scorecard.basics.country.ch': 'Zwitserland',

  'scorecard.restore.title': 'Scorecard herstellen?',
  'scorecard.restore.desc': 'We zien dat je eerder een onvoltooide scorecard ingevuld hebt. Wil je terug naar deze kaart om hem verder af te ronden of aan te passen?',
  'scorecard.restore.button.cancel': 'Nee. Nieuwe kaart',
  'scorecard.restore.button.restore': 'Ja. Herstel',

  'scorecard.basics.date.label': 'Datum',
  'scorecard.basics.course.label': 'Golfbaan',
  'scorecard.basics.loop.label': 'Lus',
  'scorecard.basics.tee.label': 'Tee',
  'scorecard.basics.holes.label': 'Aantal holes',
  'scorecard.basics.course-rating.label': 'Course Rating',
  'scorecard.basics.slope-rating.label': 'Slope Rating',
  'scorecard.basics.par.label': 'Par',
  'scorecard.basics.stableford.label': 'Stableford punten',
  'scorecard.basics.submit.label': 'Start scorekaart',

  'scorecard.button.prev': 'Vorige',
  'scorecard.button.next.hole': 'Volgende hole',
  'scorecard.button.submit': 'Scorekaart indienen',
  'scorecard.button.complete': 'Naar afronden',
  'scorecard.button.completed': 'Naar scorekaart overzicht',

  'scorecard.tabs.hole': 'Hole',
  'scorecard.tabs.si': 'Stroke Index',
  'scorecard.tabs.par': 'Par',
  'scorecard.tabs.mypar': 'Mijn par',
  'scorecard.tabs.putts': 'Puts',
  'scorecard.tabs.stableford': 'Stableford',
  'scorecard.tabs.fairway': 'Fairway hit',
  'scorecard.tabs.scores': 'Scores',
  'scorecard.tabs.distance': 'Afstand',
  'scorecard.tabs.total-hits': 'Totaal aantal slagen',
  'scorecard.tabs.optional': 'Optioneel',
  'scorecard.tabs.new-hcp': 'Nieuwe HCP',

  'scorecard.tabs.progress': 'Voortgang',
  'scorecard.tabs.hits': 'Slagen',
  'scorecard.tabs.complete': 'Afronden',

  'scorecard.submit.error': 'Helaas, het is niet gelukt om de scorecard in te zenden. Controleer je kaart en probeer het opnieuw.',
};
